import { create } from 'zustand'

interface SchoolState {
    schools: any[]
    setSchools: (data: any[], page?:number) => void;
    reset:()=>void
}

export const useSchoolStore = create<SchoolState>((set) => ({
    schools: [],
    setSchools: (data, page = 1) =>
        set((state) => ({
          schools:
            page === 1
              ? data.map((item) => ({
                  ...item,
                  visited_At: new Date(item.visited_At),
                }))
              : [
                  ...state.schools,
                  ...data.map((item) => ({
                    ...item,
                    visited_At: new Date(item.visited_At),
                  })),
                ],
        })),
    reset : ()=>set(()=>({
        schools:[]
    }))
    }));